import React from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Card } from './ui/Card';
interface LoginScreenProps {
  onLogin: () => void;
}
export function LoginScreen({
  onLogin
}: LoginScreenProps) {
  return <div className="min-h-screen w-full flex items-center justify-center bg-background p-4 relative overflow-hidden" data-id="element-153">
      {/* Background decoration */}
      <div className="absolute inset-0 grid grid-cols-[repeat(20,minmax(0,1fr))] opacity-[0.03] pointer-events-none" data-id="element-154">
        {Array.from({
        length: 400
      }).map((_, i) => <div key={i} className="border-[0.5px] border-text-secondary aspect-square" data-id="element-155" />)}
      </div>

      <Card className="w-full max-w-md relative z-10 border-border/50 shadow-2xl" data-id="element-156">
        <div className="text-center mb-8" data-id="element-157">
          {/* Orbit Logo - Circular with rings */}
          <div className="relative w-16 h-16 mx-auto mb-4" data-id="element-158">
            <div className="absolute inset-0 bg-primary/20 rounded-full animate-glow-pulse" data-id="element-159" />
            <div className="absolute inset-2 bg-primary rounded-full flex items-center justify-center shadow-glow-teal" data-id="element-160">
              <span className="font-mono font-bold text-3xl text-background" data-id="element-161">
                O
              </span>
            </div>
            {/* Orbit rings */}
            <div className="absolute -inset-1 border-2 border-primary/30 rounded-full animate-orbit-spin" style={{
            animationDuration: '8s'
          }} data-id="element-162" />
            <div className="absolute -inset-3 border border-primary/20 rounded-full animate-orbit-spin" style={{
            animationDuration: '12s',
            animationDirection: 'reverse'
          }} data-id="element-163" />
          </div>

          <h1 className="text-2xl font-bold text-text-primary mb-2" data-id="element-164">
            Welcome to Orbit
          </h1>
          <p className="text-text-secondary" data-id="element-165">
            Initialize startup simulation sequence.
          </p>
        </div>

        <div className="space-y-4" data-id="element-166">
          <Input type="email" placeholder="founder@convergent.ai" label="Email Access Key" className="bg-surface" data-id="element-167" />
          <Input type="password" placeholder="••••••••" label="Security Token" className="bg-surface" data-id="element-168" />

          <Button fullWidth size="lg" onClick={onLogin} className="mt-2" data-id="element-169">
            Initialize Session
          </Button>

          <div className="relative my-6" data-id="element-170">
            <div className="absolute inset-0 flex items-center" data-id="element-171">
              <div className="w-full border-t border-border" data-id="element-172"></div>
            </div>
            <div className="relative flex justify-center text-xs uppercase" data-id="element-173">
              <span className="bg-surface px-2 text-text-secondary" data-id="element-174">
                Or continue with
              </span>
            </div>
          </div>

          <Button variant="outline" fullWidth onClick={onLogin} data-id="element-175">
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24" data-id="element-176">
              <path fill="currentColor" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-177" />
              <path fill="currentColor" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-178" />
              <path fill="currentColor" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.84z" data-id="element-179" />
              <path fill="currentColor" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-180" />
            </svg>
            Google Workspace
          </Button>
        </div>
      </Card>
    </div>;
}